import React from 'react'
import PropTypes from 'prop-types'
import { Container } from '@scentregroup/ui'
import NationalHeader from '../components/national-header'
import CentreSelector from '../components/legacy-centre-selector'
import Promotion from '../components/promotion'
import NationalFooter from '../components/national-footer'
import withNationalHomepage from '../containers/with-national-homepage'
import withCentreSelector from '../containers/with-centre-selector'
import withGiftCards from '../containers/with-gift-cards'
import { promotionType } from '../types'
import analyticsUtils from '../helpers/analytics-utils'
import ContentGroup from '../components/content-group'
import { useCountryContext, AgentInfoContext } from '../context'
import pagesHoc from './pages-hoc'
import style from './index.module.scss'

const Index = ({ centres, homePageInfo, promotion }) => {
  const country = useCountryContext()

  return (
    <Container className={style.homeBody}>
      <AgentInfoContext.Consumer>
        {({ isMobile }) => (
          <>
            <NationalHeader />
            <CentreSelector
              centres={centres}
              homePageInfo={homePageInfo}
              isNZ={country !== 'Australia'}
              isMobile={isMobile}
            />
          </>
        )}
      </AgentInfoContext.Consumer>
      <ContentGroup angleOrigin="top-left" color="Grey" key="0">
        {promotion && (
          <Promotion
            {...promotion}
            eventCategory={analyticsUtils.categories.GIFTCARD_CLICK}
            eventAction={analyticsUtils.actions.GIFTCARD_NAT_HOME}
          />
        )}
      </ContentGroup>
      <NationalFooter />
    </Container>
  )
}

Index.propTypes = {
  centres: PropTypes.arrayOf(PropTypes.object),
  giftCards: PropTypes.object,
  nationalExperienceNavLinks: PropTypes.arrayOf(PropTypes.object),
  nationalNavLinks: PropTypes.object,
  homePageInfo: PropTypes.object,
  promotion: promotionType,
  features: PropTypes.arrayOf(PropTypes.object),
  retailers: PropTypes.arrayOf(PropTypes.object),
  featuredCategoriesCollection: PropTypes.arrayOf(PropTypes.object),
  products: PropTypes.arrayOf(PropTypes.object),
}

Index.defaultProps = {
  centres: [],
  homePageInfo: {},
}

const getHomepageStructuredData = ({ url }) =>
  url
    ? {
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        url,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${url}search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      }
    : null

const getMetaData = ({ centres, canonical }) => ({
  title: `Westfield ${centres[0].country} - Visit Our Centres or Browse Online`,
  description:
    'Westfield is your one-stop destination for shopping, leisure and entertainment. Discover 1000s of popular retailers in fashion, home, decor and more.',
  schema: getHomepageStructuredData({ url: canonical }),
})

export default withCentreSelector(
  withGiftCards(withNationalHomepage(pagesHoc(Index, getMetaData)))
)
